import { CircularProgress, Stack, Typography } from '@mui/material'
import { useLazyGetMyGrowthToolsPageQuery } from '../../../../api/growthTools'
import { GrowthToolsList } from '../../../../components/GrowthTools/GrowthToolsList'
import { useGrowthToolsQueryArgs } from '../../../../hooks/useGrowthToolsQueryArgs'
import { useGrowthToolsWindowedPage } from '../../../../hooks/useGrowthToolsWindowedPage'

export const GrowthToolsMine = () => {
  const { queryArgs, resetKey } = useGrowthToolsQueryArgs()
  const [loadGrowthToolsPage] = useLazyGetMyGrowthToolsPageQuery()
  const { items, hasMore, isInitialLoading, isFetchingMore, isError, loadMore } =
    useGrowthToolsWindowedPage(resetKey, loadGrowthToolsPage, queryArgs)

  if (isInitialLoading && items.length === 0) {
    return (
      <Stack alignItems="center" justifyContent="center" minHeight="100%">
        <CircularProgress />
      </Stack>
    )
  }

  if (isError) {
    return (
      <Typography color="error" textAlign="center" px={2}>
        Не удалось загрузить ваши инструменты роста
      </Typography>
    )
  }

  return (
    <GrowthToolsList
      growthTools={items}
      hasMore={hasMore}
      isLoadingMore={isFetchingMore}
      onLoadMore={loadMore}
      emptyMessage="Вы ещё не публиковали инструменты роста"
    />
  )
}
